import React, { useState } from 'react';
import { Input } from 'antd';
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from '../../../../columns/ib/reports/Earning.js';

export default function Earning() {

  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
    { name: 'Meera', email: 'meera@yopmail.com', account: '8541297152456', commissionDate: '15-5-2024', planName: 'Basic', userTypt: 'IB', affiliateCode: '#232KASDIW', lots: '800', commission: '6000' },
  ]);

  return (
    <div>
      <div className="flex justify-end flex-wrap gap-5">
        <div className="flex items-center">
          <div className="mr-3">
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              prefix={
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                  <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                </svg>
              }
            />
          </div>
          <div>
            <button className="bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500">Search</button>
          </div>
        </div>
      </div>

      <div className="border-[2px] border-[#F4EFFD] rounded-xl pt-4 lg:pt-6 w-full mt-5">
        <div className="px-4 lg:px-6">
          <p className="text-[#2F2B3D] text-xl font-semibold">My Earning</p>
        </div>
        <div className="my-6">
          <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
          <Pagination total={100} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
      </div>
    </div>
  )
}